import {
	DefaultHorizontalPadding,
	DefaultVerticalPadding,
} from "@styles/variables";
import styled from "styled-components";

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.secondary};
    width: 100%;

`;

export const FooterInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width:100%;
  margin: 0px auto;
  max-width: ${({ theme }) => theme.breakpoints.lg};
  padding: ${DefaultHorizontalPadding} ${DefaultVerticalPadding};


  @media(max-width:${({ theme }) => theme.breakpoints.xs}){
      padding: ${DefaultVerticalPadding} calc(${DefaultHorizontalPadding} / 2);
  }
`;
export const FooterColumns = styled.div`
  display: flex;
  justify-content: space-between;
  gap:1rem;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  h5 {
    margin-bottom: 0.5rem;
  }

  a, p {
    color: ${({ theme }) => theme.colors.secondary};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
        background-image: ${({ theme }) => theme.colors.gold};
        background-clip: text;
        color: transparent;
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.secondary};
  opacity: 0.2;
  margin: 1.5rem 0;
`;

export const AdditionalInfo = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;

  p {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.secondary};
    opacity: 0.8;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  a {
    color: ${({ theme }) => theme.colors.secondary};

    transition: color 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.gold};
      background-clip: text;
      color: transparent;
    }
  }
`;

export const BancoCentralText = styled.p`
    font-size: ${({ theme }) => theme.typeScale.lg[100]};

`;
export const Copyright = styled.p`
  margin-top: 2rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.secondary};
  opacity: 0.8;
`;
